import Vuex from 'vuex'
import { getTypes, getModule, getStore } from '../utils/storeUtil'
import { getter, mutation, action } from '../utils/vuexUtil'
import api from 'api'

export const storeName = 'common'

/** state **/
let state = {
    pageTitle: null,             // 页面头部title(非微信环境下显示)
    environmentObject: {        // 所处环境对象：微信，app，普通浏览器
        isApp: false,           // 是否是app
        isWX: false,            // 是否是微信
        isIos: false,           // 是否是ios
        isAndroid: false        // 是否是Android
    },
    buildingType: null, // 建筑类别
    buildingState: false,
    jobType: null, // 工作性质（日常服务单）
    jobState: false,
    sealType: null, // 用章类型（在线报告）
    sealState: false,
    signWayType: null, // 签收信息（在线报告）
    signWayState: false,
    professionType: null,
    professionState: false,
    projectRoleType: null, // 工程项目角色
    projectRoleState: false,
    maintenanceRoleType: null,  // 维保项目角色
    maintenanceRoleState: false,
    certType: null,     // 人员持证类型
    certState: false
}

/** getters **/
let getters = getter(state, {

})

/** mutations **/
let mutations = mutation(state, {
    // 返回：显示or隐藏
    setPageTitle(state, pageTitle) {
        state.pageTitle = pageTitle
    },
    // 返回：显示or隐藏
    setEnvironmentObject(state, environmentObject) {
        state.environmentObject = environmentObject
    },
    setBuildingType(state, buildingType) {
        state.buildingState = true
        state.buildingType = buildingType
    },
    setJobType(state, jobType) {
        state.jobState = true
        state.jobType = jobType
    },
    setSealType(state, sealType) {
        state.sealState = true
        state.sealType = sealType
    },
    setSignWayType(state, signWayType) {
        state.signWayState = true
        state.signWayType = signWayType
    },
    setProfessionType(state, professionType) {
        // state.professionState = true
        state.professionType = professionType
    },
    setProjectRoleType(state, projectRoleType) {
        // state.roleState = true
        state.projectRoleType = projectRoleType
    },
    setMaintenanceRoleType(state, maintenanceRoleType) {
        state.maintenanceRoleState = true
        state.maintenanceRoleType = maintenanceRoleType
    },
    setCertType(state, certType) {
        // state.certState = true
        state.certType = certType
    }

})

/** actions **/
let actions = action(state, {
    // 初始化环境对象
    initEnvironmentObject({ commit }, value) {
        commit('setEnvironmentObject', value)
    },
    // 设置页面title
    setPageTitle({ commit }, value) {
        commit('setPageTitle', value)
    },
    async getBuildingType({state, commit}, reload = false) {
        if (!reload && state.buildingState) return state.buildingType

        let res = await api.common.getDataDict({
            type: 'BUILDING_TYPE'
        })
        commit('setBuildingType', res)
        return res
    },
    async getJobType({state, commit}, reload = false) {
        if (!reload && state.jobState) return state.jobType

        let res = await api.common.getDataDict({
            type: 'JOB_TYPE'
        })
        commit('setJobType', res)
        return res
    },
    async getSealType({state, commit}, reload = false) {
        if (!reload && state.sealState) return state.sealType

        let res = await api.common.getDataDict({
            type: 'SEAL_TYPE'
        })
        commit('setSealType', res)
        return res
    },
    async getSignWayType({state, commit}, reload = false) {
        if (!reload && state.signWayState) return state.signWayType

        let res = await api.common.getDataDict({
            type: 'SIGN_WAY'
        })
        commit('setSignWayType', res)
        return res
    },
    async getProfessionType({state, commit}, reload = false) {
        if (!reload && state.professionState) return state.professionType

        let res = await api.common.getDataDict({
            type: 'PROFESSIONS'
        })
        commit('setProfessionType', res)
        return res
    },
    async getProjectRoleType({state, commit}, reload = false) {
        if (!reload && state.projectRoleState) return state.projectRoleType

        let res = await api.common.getRoleDict({
            projectType: 'project'
        })
        commit('setProjectRoleType', res)
        return res
    },
    async getMaintenanceRoleType({state, commit}, reload = false) {
        if (!reload && state.maintenanceRoleState) return state.maintenanceRoleType

        let res = await api.common.getRoleDict({
            projectType: 'maintenance'
        })
        commit('setMaintenanceRoleType', res)
        return res
    },
    async getCertType({state, commit}, reload = false) {
        if (!reload && state.certState) return state.certType

        let res = await api.common.getDataDict({
            type: 'CERTIFICATE_TYPE'
        })
        commit('setCertType', res)
        return res
    }
})

/** module store **/
let store = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

/** exports **/
export let types = getTypes(store)
export let module = getModule(storeName)
export let Store = getStore(module, types)

export default store



// WEBPACK FOOTER //
// ./src/store/modules/common.js